import apiService from './apiService';

export const billingService = {
  // ==================== Plans ====================

  async getPlans(): Promise<any> {
    return apiService.get('/billing/plans');
  },

  // ==================== Subscriptions ====================

  async getSubscription(): Promise<any> {
    return apiService.get('/billing/subscription');
  },

  async createCheckoutSession(data: {
    priceId: string;
    successUrl?: string;
    cancelUrl?: string;
    voucherCode?: string;
  }): Promise<any> {
    return apiService.post('/billing/checkout', data);
  },

  async createPortalSession(data?: { returnUrl?: string }): Promise<any> {
    return apiService.post('/billing/portal', data);
  },

  async cancelSubscription(data?: { reason?: string; feedback?: string }): Promise<any> {
    return apiService.post('/billing/cancel', data);
  },

  // ==================== Vouchers ====================

  async validateVoucher(code: string): Promise<any> {
    return apiService.get(`/billing/voucher/${code}/validate`);
  },

  async redeemVoucher(data: { code: string; priceId?: string }): Promise<any> {
    return apiService.post('/billing/voucher/redeem', data);
  },

  async getUserRedemptions(): Promise<any> {
    return apiService.get('/billing/voucher/redemptions');
  },

  // ==================== Admin Endpoints ====================

  async listVouchers(params?: { status?: string; page?: number; limit?: number }): Promise<any> {
    return apiService.get('/billing/admin/vouchers', { params });
  },

  async createVoucher(data: {
    code: string;
    type: 'percentage' | 'fixed_amount' | 'free_trial';
    value: number;
    maxUses?: number;
    expiresAt?: string;
    planRestrictions?: string[];
  }): Promise<any> {
    return apiService.post('/billing/admin/vouchers', data);
  },

  async updateVoucher(
    id: string,
    data: {
      status?: 'active' | 'inactive' | 'expired';
      maxUses?: number;
      expiresAt?: string;
    }
  ): Promise<any> {
    return apiService.put(`/billing/admin/vouchers/${id}`, data);
  },

  async deleteVoucher(id: string): Promise<void> {
    return apiService.delete(`/billing/admin/vouchers/${id}`);
  },

  async getVoucherStats(id: string): Promise<any> {
    return apiService.get(`/billing/admin/vouchers/${id}/stats`);
  },
};
